import script from "./VisaPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisaPay.vue?vue&type=script&setup=true&lang=ts"

import "./VisaPay.vue?vue&type=style&index=0&id=43e92fa6&lang=css"

const __exports__ = script;

export default __exports__